export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const UPDATE_USER = 'UPDATE_USER' 

export const PERSIST_USER_DATA = "PERSIST_USER_DATA";
